import { ScrollableTableResponse } from '@chilipiper/api-type-def'

type UserId = string
type GroupBookingLinkId = string
type WorkspaceId = string
type TemplateId = string
type Minutes = number
type Instant = string

export type LinkType = 'Individual' | 'Group'
type ContactMethod = 'Phone' | 'Video'
type CalendarStatus = 'Connected' | 'Disconnected' | 'InTrouble'

export enum BookingLinksListType {
  All = 'All',
  CreatedByMe = 'CreatedByMe',
  SharedWithMe = 'SharedWithMe',
}

export type ApiBookingLink = {
  contactMethods: ContactMethod[]
  createdAt?: Instant
  createdBy?: Author
  duration?: Minutes
  hasCrmActions: boolean
  id?: GroupBookingLinkId
  isDefault: boolean
  isPersonal: boolean
  link?: string
  linkType: LinkType
  links?: Link[]
  members: Member[]
  name: string
  templateId: TemplateId
  updatedAt?: Instant
  workspaceId?: WorkspaceId
}

export type Member = {
  id: UserId
  isHost: boolean
  isOptional: boolean
  name: string
}

type Author = {
  email: string
  id: UserId
  name: string
}

export type SaveRequest = {
  id?: GroupBookingLinkId
  members: Member[]
  templateId: string
}

export type Link = {
  calendarStatus: CalendarStatus
  path: string
  userId: UserId
  userName: string
}

export interface AdminIndividualBookingLinkResponse extends ScrollableTableResponse<Link> {
  templateName: string
}

export interface AllRequest {
  userId?: string
  workspaceId?: string
}

export enum BookingLinksGroupBy {
  Workspace = 1,
  Duration,
  ContactMethod,
}

export interface AdminIndividualBookingLink {
  contactMethods: ContactMethod[]
  createdAt?: Instant
  createdBy?: Author
  duration?: Minutes
  hasCrmActions: boolean
  isDefault: boolean
  isPersonal: boolean
  name: string
  templateId: TemplateId
  updatedAt?: Instant
  workspaceId: WorkspaceId
}

export interface AdminIndividualBookingLinksResponse
  extends ScrollableTableResponse<AdminIndividualBookingLink> {
  userCount: number
}

export interface AdminGroupBookingLink {
  contactMethods: ContactMethod[]
  createdAt?: Instant
  createdBy?: Author
  duration?: Minutes
  groupLinkName?: string
  hasCrmActions: boolean
  id: GroupBookingLinkId
  isDefault: boolean
  isPersonal: boolean
  link: string
  members: Member[]
  name: string
  templateId: TemplateId
  updatedAt?: Instant
  workspaceId: WorkspaceId
}

export type AdminGroupBookingLinksResponse = ScrollableTableResponse<AdminGroupBookingLink>
